import api_urls from "@/api_urls";
import { getAuthState } from "@/store/auth.state";
import { AuthTokenData } from "@vixi/types";
import axios, { AxiosResponse, HttpStatusCode } from "axios";
import { logger } from "@vixi/utils";
import { endpoints } from "@/endpoints";

const createRefreshTokenFn = (maxAttempts = 5) => {
  let currentAttempt: Promise<AuthTokenData | void> | null = null;

  return async () => {
    if (currentAttempt) {
      return currentAttempt;
    }

    const refresh = async () => {
      let attemptCount = 0;
      logger.debug("Refreshing access token");

      const attemptRefresh = async (): Promise<AuthTokenData | void> => {
        const authState = getAuthState();

        return axios
          .post(
            endpoints.refresh,
            {
              refreshToken: authState.refreshToken,
            },
            {
              baseURL: api_urls.coursemaker,
            },
          )
          .then((response: AxiosResponse<AuthTokenData>) => {
            getAuthState().setTokenData(response.data);

            return response.data;
          })
          .catch((e) => {
            if (e.status === HttpStatusCode.Unauthorized || ++attemptCount >= maxAttempts) {
              throw e;
            } else return attemptRefresh();
          });
      };

      currentAttempt = attemptRefresh();
      return currentAttempt.finally(() => {
        currentAttempt = null;
      });
    };

    return refresh();
  };
};

export const refreshAccessToken = createRefreshTokenFn();
